import { createSelector } from '@reduxjs/toolkit';
import { getChannelListState } from './getChannelListState';

export const getUnreadMessagesFilterSelected = createSelector(
  getChannelListState,
  (channelList) => channelList.unreadMessagesFilterSelected,
);
